export const authConstants = {
    LOGIN_REQUEST:"LOGIN_REQUEST",
    LOGIN_FAILED:"LOGIN_FAILED",
    LOGIN_SUCCESS:"LOGIN_SUCCESS",
    LOGOUT_REQUEST:"LOGOUT_REQUEST",
    LOGOUT_SUCCESS:"LOGOUT_SUCCESS",
    LOGOUT_FAILED:"LOGOUT_FAILED"
}

export const dashboardConstats = {
    GET_DOCUMENTS_REQUEST:"GET_DOCUMENTS_REQUEST",
    GET_DOCUMENTS_SUCCESS:"GET_DOCUMENTS_SUCCESS",
    GET_DOCUMENTS_FAILED:"GET_DOCUMENTS_FAILED",
    Add_DOCUMENT_REQUEST:"Add_DOCUMENT_REQUEST",
    Add_DOCUMENT_SUCCESS:"Add_DOCUMENT_SUCCESS",
    Add_DOCUMENT_FAILED:"Add_DOCUMENT_FAILED",
    DELETE_DOCUMENT_REQUEST:"DELETE_DOCUMENT_REQUEST",
    DELETE_DOCUMENT_SUCCESS:"DELETE_DOCUMENT_SUCCESS",
    DELETE_DOCUMENT_FAILED:"DELETE_DOCUMENT_FAILED",
    DOWNLOAD_DOCUMENT_REQUEST:"DOWNLOAD_DOCUMENT_REQUEST",
    DOWNLOAD_DOCUMENT_SUCCESS:"DOWNLOAD_DOCUMENT_SUCCESS",
    DOWNLOAD_DOCUMENT_FAILED:"DOWNLOAD_DOCUMENT_FAILED"
}

export const creatAccountConstants = {
    CREATE_ACCOUNT_REQUEST:"CREATE_ACCOUNT_REQUEST",
    CREATE_ACCOUNT_SUCCESS:"CREATE_ACCOUNT_SUCCESS",
    CREATE_ACCOUNT_FAILED:"CREATE_ACCOUNT_FAILED"
}

export const helpingConstants = {
        CHANGE_LOGOUT:"CHANGE_LOGOUT",
        CLEAR_MODAL_ERROR:"CLEAR_MODAL_ERROR"
}

export const contactUsConstants = {
    CONTACTUS_REQUEST:"CONTACTUS_REQUEST",
    CONTACTUS_SUCCESS:"CONTACTUS_SUCCESS",
    CONTACTUS_FAILED:"CONTACTUS_FAILED"
}